import React, { useState } from 'react'
import * as PropTypes from 'prop-types'

const ExpandableDrawerContext = React.createContext([null, () => {}])

const ExpandableDrawerProvider = ({ children }) => {
  const [contentRef, setContentRef] = useState(null)

  return (
    <ExpandableDrawerContext.Provider value={[contentRef, setContentRef]}>
      {children}
    </ExpandableDrawerContext.Provider>
  )
}

ExpandableDrawerProvider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({})),
}
ExpandableDrawerProvider.defaultProps = {
  children: null,
}

export { ExpandableDrawerContext, ExpandableDrawerProvider }
